// components
import DialogHeader from '../DialogHeader';
import AuthChangePassword from 'sections/auth/auth-forms/AuthChangePassword';

// Mui
import { Theme } from '@mui/material/styles';
import { Dialog, DialogContent, DialogProps, Divider, useMediaQuery } from '@mui/material';

interface ChangePasswordDialogProps extends Omit<DialogProps, 'onClose'> {
  onClose?: () => void;
}

function ChangePasswordDialog({ onClose, ...others }: ChangePasswordDialogProps) {
  const matchDownMD = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: 600 } }}
      maxWidth={matchDownMD ? 'sm' : 'lg'}
      {...others}
      onClose={handleClose}
    >
      <DialogHeader onClose={handleClose}>Change Password</DialogHeader>
      <Divider />
      <DialogContent>
        <AuthChangePassword changePasswordFlow onSuccess={handleClose} />
      </DialogContent>
    </Dialog>
  );
}

export default ChangePasswordDialog;
